import { useContext, useEffect } from 'react';
import { IsGoogleMapsLoadingContext, RunGoogleMapsEffectContext } from '../context';
export var useIsGoogleMapsLoading = function () { return useContext(IsGoogleMapsLoadingContext); };
export var useRunGoogleMapsEffect = function () { return useContext(RunGoogleMapsEffectContext); };
export var useGoogleMaps = function () {
    var isLoading = useIsGoogleMapsLoading();
    var runMapsEffect = useRunGoogleMapsEffect();
    useEffect(function () {
        runMapsEffect();
    }, []);
    return isLoading;
};
//# sourceMappingURL=google-maps-hooks.js.map